import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
})
export class WidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.initWidget();
  }

  initWidget() {
    console.log('Widget initialized');
    const script = document.createElement('script');
    script.src = 'https://compramas.planitondemand.com.mx/widget.js';
    script.async = true;
    script.onload = () => {
      (window as any).ChatWidget?.init({
        idAdmin: 68,
        urlSocket: 'https://as-backend.planitondemand.com.mx/'
      });
    };
    document.body.appendChild(script);
  }

}
